module.exports = __webpack_public_path__ + "static/media/files.3dfe14d6.svg";